import React from 'react';

export default function SVGMiniQR(): JSX.Element {
  return (
    <svg width="15" height="13" viewBox="0 0 15 13" fill="#fff" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 5.404h1.59v1.35H0v-1.35zM6.358 1.35h1.59v2.702h-1.59V1.35zm-1.59 4.053h3.18v2.702h-1.59V6.755h-1.59V5.404zm4.769 0h1.59v1.35h1.589v-1.35h1.59v1.35h-1.59v1.352h1.59v2.702h-1.59v1.35h-1.59v-1.35H7.947v1.35H6.358V9.458h3.179V8.106h1.59V6.755h-1.59V5.404zm3.179 5.404V8.106h-1.59v2.702h1.59zM9.537 0h4.768v4.053H9.537V0zm1.59 1.351v1.35h1.589v-1.35h-1.59zM0 0h4.768v4.053H0V0zm1.59 1.351v1.35h1.589v-1.35h-1.59zM0 8.106h4.768v4.053H0V8.106zm1.59 1.35v1.352h1.589V9.457h-1.59z" />
    </svg>
  );
}
